import {
  createErrorType,
  createSuccessType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createUpdateType,
} from '../actionHelpers';

// FundingSource
const FUNDING_SOURCE_SCOPE = 'FUNDING_SOURCE';
export const GET_FUNDING_SOURCE = createFetchType(FUNDING_SOURCE_SCOPE);
export const GET_FUNDING_SOURCE_SUCCESS = createSuccessType(
  FUNDING_SOURCE_SCOPE,
);
export const GET_FUNDING_SOURCE_ERROR = createErrorType(FUNDING_SOURCE_SCOPE);
export const GET_FUNDING_SOURCE_LOADING = createLoadingType(
  FUNDING_SOURCE_SCOPE,
);

const APPLICATION_FUNDING_SOURCE_SCOPE = 'APPLICATION_FUNDING_SOURCE';
export const APPLICATION_FUNDING_SOURCE = createSubmitType(
  APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const APPLICATION_FUNDING_SOURCE_SUCCESS = createSuccessType(
  APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const APPLICATION_FUNDING_SOURCE_ERROR = createErrorType(
  APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const APPLICATION_FUNDING_SOURCE_LOADING = createLoadingType(
  APPLICATION_FUNDING_SOURCE_SCOPE,
);

const UPDATE_APPLICATION_FUNDING_SOURCE_SCOPE =
  'UPDATE_APPLICATION_FUNDING_SOURCE';
export const UPDATE_APPLICATION_FUNDING_SOURCE = createUpdateType(
  UPDATE_APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_SOURCE_SUCCESS = createSuccessType(
  UPDATE_APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_SOURCE_ERROR = createErrorType(
  UPDATE_APPLICATION_FUNDING_SOURCE_SCOPE,
);
export const UPDATE_APPLICATION_FUNDING_SOURCE_LOADING = createLoadingType(
  UPDATE_APPLICATION_FUNDING_SOURCE_SCOPE,
);

const FUNDING_SOURCE_DETAILS_SCOPE = 'FUNDING_SOURCE_DETAILS';
export const GET_FUNDING_SOURCE_ACCOUNT_DETAILS = createFetchType(
  FUNDING_SOURCE_DETAILS_SCOPE,
);
export const GET_FUNDING_SOURCE_ACCOUNT_DETAILS_ERROR = createErrorType(
  FUNDING_SOURCE_DETAILS_SCOPE,
);
export const GET_FUNDING_SOURCE_ACCOUNT_DETAILS_SUCCESS = createSuccessType(
  FUNDING_SOURCE_DETAILS_SCOPE,
);
export const GET_FUNDING_SOURCE_ACCOUNT_DETAILS_LOADING = createLoadingType(
  FUNDING_SOURCE_DETAILS_SCOPE,
);

const FUNDING_ACCOUNT_PURPOSE_SCOPE = 'FUNDING_ACCOUNT_PURPOSE';
export const GET_FUNDING_ACCOUNT_PURPOSE = createFetchType(
  FUNDING_ACCOUNT_PURPOSE_SCOPE,
);
export const GET_FUNDING_ACCOUNT_PURPOSE_ERROR = createErrorType(
  FUNDING_ACCOUNT_PURPOSE_SCOPE,
);
export const GET_FUNDING_ACCOUNT_PURPOSE_SUCCESS = createSuccessType(
  FUNDING_ACCOUNT_PURPOSE_SCOPE,
);
export const GET_FUNDING_ACCOUNT_PURPOSE_LOADING = createLoadingType(
  FUNDING_ACCOUNT_PURPOSE_SCOPE,
);
